import React,{useState} from 'react'
import Modal from '../../../components/Modal'

export default function IncludeTutorModal({setIncludeTutor,enquiry,tutor,onClick}) {

  return (
    <Modal title="Exclude Tutor" size="md">
        <div className="modal-inner-content">
            <p className="r-text m-weight f-op">Are you sure you want to include this tutor for this enquiry?</p>
        </div>
        <div className="modal-footer">
            <button className="xs-neutral-btn" onClick={()=>setIncludeTutor(false)}>Cancel</button>
            <button className="xs-delete-btn" onClick={()=>onClick()}>Include</button>
        </div>
    </Modal>
  )
}
